export default "__VITE_ASSET__B7H6goxj__"